import React from 'react';
import { Star, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
const stats = [{
  value: '+500',
  label: 'docentes confían'
}, {
  value: '7',
  label: 'Tomos listos + BONOS'
}, {
  value: '4.9/5',
  label: 'calificación',
  hasStar: true
}, {
  value: 'LATAM',
  label: 'Para docentes de educación secundaria de países hispanohablantes de América Latina'
}];
const testimonials = [{
  initials: 'CG',
  name: 'Camila G.',
  location: 'Buenos Aires, Argentina',
  specialty: 'Docente de Biología',
  quote: '"Organicé mis clases con una secuencia mucho más clara."',
  color: 'bg-blue-600'
}, {
  initials: 'DR',
  name: 'Daniela R.',
  location: 'Santiago, Chile',
  specialty: 'Profesora de Ciencias Naturales',
  quote: '"Ahora tengo actividades listas para cada nivel."',
  color: 'bg-indigo-600'
}, {
  initials: 'AM',
  name: 'Andrés M.',
  location: 'Medellín, Colombia',
  specialty: 'Docente de Biología',
  quote: '"Las evaluaciones y rúbricas me ayudan a ahorrar mucho tiempo."',
  color: 'bg-sky-600'
}];
export function SocialProof() {
  return <section className="pt-4 pb-6 md:py-20 px-4 max-w-7xl mx-auto" data-id="element-226">
      {/* Stats Grid */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-8 md:mb-20" data-id="element-227">
        {stats.map((stat, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="text-center" data-id="element-228">
            <div className="flex items-center justify-center gap-1 mb-1 md:mb-2" data-id="element-229">
              <span className="text-3xl md:text-5xl font-black text-emerald-600" data-id="element-230">
                {stat.value}
              </span>
              {stat.hasStar && <Star className="fill-emerald-600 text-emerald-600 w-4 h-4 md:w-6 md:h-6" data-id="element-231" />}
            </div>
            <p className="text-slate-600 font-bold text-[10px] md:text-base uppercase tracking-wide" data-id="element-232">
              {stat.label}
            </p>
          </motion.div>)}
      </div>

      {/* Testimonials Grid */}
      <div className="grid md:grid-cols-3 gap-4 md:gap-6" data-id="element-233">
        {testimonials.map((t, index) => <motion.div key={index} initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1 + 0.4
      }} className="bg-white p-6 md:p-8 rounded-3xl shadow-xl shadow-emerald-900/5 border border-emerald-50 relative overflow-hidden group" data-id="element-234">
            <div className="flex items-center gap-3 md:gap-4 mb-4 md:mb-6" data-id="element-235">
              <div className={`${t.color} w-10 h-10 md:w-12 md:h-12 rounded-xl md:rounded-2xl flex items-center justify-center text-white font-black text-base md:text-lg shadow-lg`} data-id="element-236">
                {t.initials}
              </div>
              <div data-id="element-237">
                <div className="flex gap-0.5 mb-1" data-id="element-238">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-emerald-600 text-emerald-600" data-id="element-239" />)}
                </div>
                <p className="text-xs font-bold text-slate-400 uppercase tracking-tighter" data-id="element-240">
                  Perfil representativo
                </p>
              </div>
            </div>

            <blockquote className="text-base md:text-lg font-bold text-slate-800 mb-4 md:mb-6 leading-tight" data-id="element-241">
              {t.quote}
            </blockquote>

            <div className="flex items-center justify-between pt-4 md:pt-6 border-t border-slate-50" data-id="element-242">
              <div className="text-xs md:text-sm" data-id="element-243">
                <p className="font-black text-slate-900" data-id="element-244">{t.name}</p>
                <div className="flex items-center gap-1 text-slate-500 font-medium" data-id="element-245">
                  <MapPin size={12} data-id="element-246" />
                  <span data-id="element-247">
                    {t.location} | {t.specialty}
                  </span>
                </div>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}